import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4adb1f9b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4adb1f9b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adb1f9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4adb1f9b')) {
      api.createRecord('4adb1f9b', component.options)
    } else {
      api.reload('4adb1f9b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4adb1f9b&scoped=true", function () {
      api.rerender('4adb1f9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/sele-container/index.vue"
export default component.exports